<script lang="ts">
    import type { TopInfo } from '@shared/types/types';

    interface Props {
        infos: TopInfo[] | undefined;
        multipleSizes: boolean;
    }

    let { infos, multipleSizes }: Props = $props();
</script>

{#if infos?.length && !multipleSizes}
    <dl class="reptile-top-info">
        {#each infos.slice(0, 3) as info (info)}
            <div class="reptile-top-info__item">
                <dd class="reptile-top-info__value">
                    {info.value}
                </dd>
                <dt class="reptile-top-info__label">{info.label}</dt>
            </div>
        {/each}
    </dl>
{:else if infos?.length && multipleSizes}
    <dl class="reptile-top-info">
        <div class="reptile-top-info__item">
            <dd class="reptile-top-info__value">Mehrere Größen</dd>
        </div>
    </dl>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    /**
 *
 *
 *
 */
    .reptile-top-info {
        display: flex;
        flex-direction: column;
        gap: tokens.$oc-semantic-spacing-absolute-25;
        font: tokens.$oc-semantic-font-copy-75;

        &__item {
            @include mixins.ellipsis(nowrap);
        }

        &__label,
        &__value {
            display: inline;
        }

        &__value {
            font-weight: tokens.$oc-base-font-weight-regular;
            color: tokens.$oc-semantic-color-text-default;
        }
    }
</style>
